const getDeliveryDetails = deliveryFee => {
  if (!deliveryFee || !deliveryFee.amount) {
    return ' Free Delivery';
  }
  if (deliveryFee.freeDeliveryMoreThanEnabled) {
    if (
      deliveryFee.freeDeliveryMoreThanAmount &&
      deliveryFee.amount < deliveryFee.freeDeliveryMoreThanAmount
    ) {
      return ` Free Delivery after £${parseFloat(
        deliveryFee.freeDeliveryMoreThanAmount
      ).toFixed(2)}`;
    } else {
      return ` Free Delivery after £${parseFloat(deliveryFee.amount).toFixed(
        2
      )}`;
    }
  } else {
    return ` £${parseFloat(deliveryFee.amount).toFixed(2)} Delivery Fee`;
  }
};

export default getDeliveryDetails;
